
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding/success",
      function () {
        return require("private-next-pages/onboarding/success.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onboarding/success"])
      });
    }
  